import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Payment Method',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Payment Method',
        href: '/adm/cara-bayar',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_pay_method',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'code_pay',
        label: 'Kode',
        sortable: true,
        thStyle: {
          width: '150px',
        },
      },
      {
        key: 'payment_name',
        label: 'Payment Name',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Payment Type',
        sortable: true,
      },
      {
        key: 'payment_active',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '80px',
        },
      },
    ],
    detail: false,
    form: {},
    import_form: [],
    options: [
      'Tunai',
      'Kredit',
      'Kartu Kredit',
      'Kartu Debit',
      'Mobile Payment',
      'Transfer Bank',
      'Prepaid Card',
    ],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changePayMethod(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchPayMethod(context, params = null) {
    let result = await ApiGetRequest(`payment-method`, params);
    return !result.error ? result.data.object : [];
  },

  async getListPayMethod({ commit, state }, payload = {}) {
    commit('changePayMethod', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`payment-method`, params);
      commit('changeEmployee', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_payment.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`payment-method`, params);
      commit('changePayMethod', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailPayMethod({ commit, state }, payload = null) {
    commit('changePayMethod', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`payment-method/${payload.id}`);
    commit('changePayMethod', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
        em_user_pwd: '',
      },
    });

    return result.error ? false : true;
  },

  async uploadImagePayMethod({ commit, state }, payload) {
    commit('changePayMethod', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changePayMethod', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayMethod', {
        form: {
          ...data.form,
          prod_img: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changePayMethod', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`payment-method/import`, {
      items: data.import_form || [],
    });

    commit('changePayMethod', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createPayMethod({ commit, state, dispatch }) {
    commit('changePayMethod', {
      loading: true,
    });

    let result = await ApiPostRequest(`payment-method`, state.data.form);
    commit('changePayMethod', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updatePayMethod({ commit, state, dispatch }, payload = null) {
    commit('changePayMethod', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `payment-method/${payload.id}`,
      state.data.form
    );

    commit('changePayMethod', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePayMethod({ commit, dispatch }, payload = null) {
    commit('changePayMethod', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`payment-method/${payload.id}`);
    commit('changePayMethod', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
